import { render, staticRenderFns } from "./DynamicLabel.vue?vue&type=template&id=263a1349&"
import script from "./DynamicLabel.vue?vue&type=script&lang=js&"
export * from "./DynamicLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports